"use client";

import { useContext } from "react";
import { BootstrapContext } from "../providers/BootstrapProvider";
import { pickSetting } from "@/shared/settings";
import type { SettingType } from "@/shared/settings";
import type { BootstrapData } from "../types/bootstrap";

export function useBootstrap(): BootstrapData {
    const data = useContext(BootstrapContext);

    if (!data) {
        throw new Error("useBootstrap deve ser usado dentro de <BootstrapProvider>");
    }

    return data;
}

export const useAppSettings = () => useBootstrap().settings;

export const useAppBoot = () => useBootstrap().boot;

/** Modo de exibição de produto sem estoque ('hide' é o padrão). */
export const useOutOfStockDisplay = (): "hide" | "notify_me" =>
    useAppBoot()?.out_of_stock_display === "notify_me" ? "notify_me" : "hide";

/** Comportamento do botão "Adicionar" no card de produto ('redirect_to_cart' é o padrão). */
export const useAddToCartBehavior = (): "redirect_to_cart" | "quantity_stepper" =>
    useAppBoot()?.add_to_cart_behavior === "quantity_stepper" ? "quantity_stepper" : "redirect_to_cart";

/** Abertura pela loja mais próxima (pede a localização no primeiro acesso). */
export const useNearestStoreOnInit = (): boolean => {
    const boot = useAppBoot();
    return boot?.can_change_store === true && boot?.nearest_store_on_init === true;
};

export const useAvailableStores = () => useBootstrap().stores;

export const useAuthFormFields = () => useBootstrap().authFields;

export const useFooterGroups = () => useBootstrap().footerGroups;

/** Loja resolvida no SSR — semeia a loja ativa no cliente. */
export const useResolvedStoreId = () => useBootstrap().storeId;

/** Ex.: `useAppSetting<AppIdentityContent>("app_identity")`. */
export function useAppSetting<TContent>(type: SettingType): TContent | null {
    return pickSetting<TContent>(useAppSettings(), type);
}
